import { apiFetch } from '../client';

/**
 * ABM "Cuotas MercadoPago" (server: /api/mp-cuotas): % de recargo sobre el
 * total factura según la cantidad de cuotas. AR.
 */
export type MpCuota = {
  /** String para CrudTable. */
  id: string;
  cuotas: number;
  porcentaje: number;
  status: 'Activo' | 'Inactivo';
};

/** Query key compartida: ABM y pantalla de Pagos. */
export const MP_CUOTAS_QUERY_KEY = ['mp-cuotas'] as const;

type Row = { id: number; cuotas: number; porcentaje: number; status: 'Activo' | 'Inactivo' };
const aItem = (r: Row): MpCuota => ({ ...r, id: String(r.id) });

export async function listMpCuotas(): Promise<MpCuota[]> {
  const res = await apiFetch<{ items: Row[] }>('/api/mp-cuotas');
  return res.items.map(aItem);
}

export type MpCuotaPayload = { cuotas: number; porcentaje: number; status: 'Activo' | 'Inactivo' };

export async function createMpCuota(p: MpCuotaPayload): Promise<MpCuota> {
  const res = await apiFetch<{ item: Row }>('/api/mp-cuotas', { method: 'POST', body: p });
  return aItem(res.item);
}

export async function updateMpCuota(id: string, p: MpCuotaPayload): Promise<MpCuota> {
  const res = await apiFetch<{ item: Row }>(`/api/mp-cuotas/${id}`, { method: 'PATCH', body: p });
  return aItem(res.item);
}

export async function softDeleteMpCuota(id: string): Promise<MpCuota> {
  const res = await apiFetch<{ item: Row }>(`/api/mp-cuotas/${id}`, { method: 'DELETE' });
  return aItem(res.item);
}

/** "11,40%" */
export const fmtPct = (n: number) =>
  `${n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
